import T from '../../../common/components/T';
import PropTypes from 'prop-types';
import css from './GridNoData.module.scss';

const GridNoData = ({ title }) => {
    return (
        <div className={css.gridPlugWrap}>
            <p className={css.gridPlugText}>
                {title || (
                    <T
                        textName='noDataAlert'
                        defaultStr='По Вашему запросу не было найдено ни одного совпадения. Измените поисковый запрос или воспользуйтесь расширенным поиском.'
                        page='all'
                    />
                )}
            </p>
        </div>
    );
};
GridNoData.propTypes = { title: PropTypes.node };

export default GridNoData;
